import _ from 'lodash'
import queryString from 'query-string'

const defaultOptions = {
  method: 'GET'
}

const prefix = process.env.REACT_APP_API_URL || '/api'

const status = res => {
  if (!res.ok) throw res
  return res
}

const json = (key, callback, context) => res => {
  if (res.status === 204 || !res.json) return res

  return res
    .json()
    .then(
      json => callback.call(context, Object.assign(res, { [key]: json })),
      () =>
        callback.call(
          context,
          Object.assign(res, { [key]: { error: { details: `${res.status}: ${res.statusText}` } } })
        )
    )
}

const success = json('json', Promise.resolve, Promise)

const error = json('error', Promise.reject, Promise)

export default (url, { method, body } = defaultOptions) => (...args) => {
  const { getState } = _.last(args)
  const [body] = _.initial(args)
  const search = method === 'GET' && body ? '?' + queryString.stringify(body) : ''
  const state = getState()
  const authorization = _.get(state, 'users.authorization')
  const locale = _.get(state, 'i18n.locale')

  const config = {
    method,
    headers: new Headers({
      ...(authorization ? { authorization } : {}),
      ...(body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
      'x-language': locale,
      Accept: 'application/json'
    }),
    body: method === 'GET' ? undefined : body instanceof FormData ? body : JSON.stringify(body)
  }

  return fetch(`${prefix}${url}${search}`, config)
    .then(status)
    .then(success, error)
}



// WEBPACK FOOTER //
// ./src/core/api/index.js